import React, {useCallback, useRef} from 'react'
import {getSisDateAsISO, getSisDateAsNumber, parseSisDate} from 'util/SisDateTime'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment/moment'
import {Datepicker} from 'component/Datepicker'
import {cssCFInput} from 'module/CustomField/style/cssCFInput'
import {SetCb} from 'type/SetCb'
import {focusNextFormElement} from 'util/view/focusNextFormElement'

interface Props {
	value: number | null | undefined
	onChange: SetCb<number | null | undefined>
	disabled?: boolean
	placeholderText?: string
	className?: string
}

export const DateComponent = React.memo(function DateComponent(props: Props) {
	const {value, onChange, disabled, placeholderText, className} = props
	const mom = value && parseSisDate(value) || undefined
	let selected = mom?.isValid() ? mom?.toDate() : null
	const ref = useRef<ReactDatePicker>(null)

	const onChangeDate = useCallback((date: Date | null, event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
		if (disabled) return;
		onChange(getSisDateAsNumber(moment(date)))
		focusNextFormElement(1, {event, inputEl: ref.current?.input as HTMLInputElement, focusNextOnlyInForm: true});
	}, [onChange, disabled, ref.current?.input])

	const onBlur = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
		if (disabled) return;
		const date = parseSisDate(event.target.value)
		const isoDate = getSisDateAsISO(date)
		if (date?.isValid() && isoDate !== ref.current?.state.inputValue) {
			// todo remove react-datepicker workaround: fixes first change not refreshed in input field
			ref.current?.setState({inputValue: isoDate})
		}
		onChange(getSisDateAsNumber(date))
	}, [onChange, disabled, ref.current])

	return <Datepicker
		className={className}
		css={cssCFInput}
		ref={ref}
		placeholderText={placeholderText}
		selected={selected}
		disabled={disabled}
		onChange={onChangeDate}
		onBlur={onBlur}
		todayButton={"Heute"}
		isClearable={false}
	/>
})